import { channelClient, RequestPolicies } from 'shared/channels';
import { createEntityClient, runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { contractChannelContract } from './contractChannelContract';
import type { ContractCreateModel, ContractEditModel, ContractModel } from './types/model';

/**
 * Contracts of the selected project as served by the service worker. Changes
 * resolve once the server accepted them and reject with its error
 * (`ChannelRequestError.messageId`).
 */
export const contractClient = {
  ...createEntityClient(contractChannelContract),

  /** One item for its details view, archived ones included; rejects when there is none. */
  getOneById(id: string): Promise<ContractModel> {
    return channelClient.request(contractChannelContract, 'getOneById', { id }, RequestPolicies.read);
  },

  /** Resolves with the saved contract. */
  create(contractCreateModel: ContractCreateModel): Promise<ContractModel> {
    return runQueuedMutation(
      contractChannelContract,
      'create',
      (uniqueId) => ({ contractCreateModel, uniqueId }),
      DomainMessagesTypes.createdEntity
    );
  },

  async edit(contractEditModel: ContractEditModel): Promise<void> {
    await runQueuedMutation(
      contractChannelContract,
      'edit',
      (uniqueId) => ({ contractEditModel, uniqueId }),
      DomainMessagesTypes.updatedEntity
    );
  },
};
